import { createClient } from "@/app/utils/supabase/client";
import type { ServiceCategoryT } from "@/app/types/services";

export async function getAllServiceCategories(): Promise<
  ServiceCategoryT[] | null
> {
  const supabase = createClient();

  const { data, error } = await supabase
    .from("service_categories")
    .select(
      `
      id,
      created_at,
      updated_at,
      label,
      key,
      slug
    `
    )
    .order("label");

  if (error) {
    console.error("Fehler beim Abrufen der Service-Kategorien:", error);
    return null;
  }

  if (!data) return [];

  return data as ServiceCategoryT[];
}
